import { WifiOff, Headphones, ShieldCheck, Undo2 } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Guarantee = {
  label: string;
  title: string;
  desc: string;
  Icon: typeof WifiOff;
};

const GUARANTEES: ReadonlyArray<Guarantee> = [
  {
    label: 'Offline par design',
    title: '100% hors-ligne',
    desc: "La caisse ne dépend pas d'internet. La synchro se fait quand le réseau revient — sans jamais bloquer une vente.",
    Icon: WifiOff,
  },
  {
    label: 'Support humain',
    title: 'Français natif',
    desc: 'Un·e humain·e répond, pas un bot. Sur les fuseaux horaires africains, pas un callcenter délocalisé.',
    Icon: Headphones,
  },
  {
    label: 'Tes données · à toi',
    title: 'Chiffrées, exportables',
    desc: "Chiffrement en local et en transit. Export complet à tout moment. On ne revend rien. On n'ouvre pas tes ventes.",
    Icon: ShieldCheck,
  },
  {
    label: 'Zéro engagement',
    title: 'Libre à chaque mois',
    desc: '14 jours gratuits sans carte bancaire. Résiliation en un clic. On ne piège personne par contrat.',
    Icon: Undo2,
  },
];

export default function StatsGridV2() {
  return (
    <section className="bg-charcoal-800 py-24 text-white md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <SectionLabel tone="dark">Ce qu'on garantit</SectionLabel>
            <h2 className="mt-6 font-marketing-display text-[clamp(32px,4.2vw,56px)] font-bold leading-[1] tracking-[-0.035em]">
              Pas de promesses.
              <br />
              <span className="text-lime-400">Des garanties.</span>
            </h2>
          </div>
          <p className="max-w-sm font-marketing-body text-[15px] leading-relaxed text-charcoal-200">
            On préfère être mesurés sur ce qu'on livre plutôt que sur ce qu'on raconte. Ces quatre
            engagements sont écrits dans le produit, pas dans le pitch.
          </p>
        </div>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {GUARANTEES.map((g) => (
            <li
              key={g.title}
              className="flex h-full flex-col border-2 border-charcoal-700 bg-charcoal-700 p-7 shadow-neobrutal-lime-6"
            >
              <div className="flex h-14 w-14 items-center justify-center border-2 border-lime-400 bg-charcoal-800 text-lime-400">
                <g.Icon className="h-6 w-6" strokeWidth={2.2} />
              </div>
              <div className="mt-6 font-marketing-mono text-[11px] font-medium uppercase tracking-[0.14em] text-charcoal-200">
                {g.label}
              </div>
              <div className="mt-2 font-marketing-display text-[24px] font-bold leading-[1.1] tracking-[-0.02em] text-white">
                {g.title}
              </div>
              <p className="mt-4 font-marketing-body text-[14.5px] leading-relaxed text-charcoal-200">
                {g.desc}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
